import axios from "axios";
import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import HeadstartLayout from "@layouts/HeadStartLayout";
// import Editor from "@components/editor";
import { NextPageWithLayout } from "@pages/_app";
import { Prisma } from "@prisma/client";
import { toast } from "react-toastify";
import LoaderOverlay from "@components/Loader/Overlay";
import BrandButton from "@components/Button/Brand";
import withPaywall from "@utils/HOC/withPaywall";
import { trpc } from "@utils/trpc";
// import { configureAbly, useChannel } from "@ably-labs/react-hooks"; // Removed Ably
import { useUser } from "@clerk/nextjs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { createServerSideHelpers } from "@trpc/react-query/server";
import { appRouter } from "@server/routers/_app";
import { createContext } from "@server/context";
import superjson from "superjson";
import LexicalEditor from "@components/Editor/Lexical";
import { LoadingSmall } from "@components/LoadingSmall";
import { motion, AnimatePresence } from "framer-motion";
import { DummyBars } from "@components/DummyEditorPage";

interface saveInput extends Prisma.PostUpdateInput {
  id: string;
}

let x = 1;
const t = (v) => x * v;

let checkIconTransition = {
  ease: "easeOut",
  type: "tween",
  delay: t(0.2),
  duration: t(0.3),
};
let checkIconVariants = {
  complete: {
    pathLength: [0, 1],
  },
};
let backgroundTransition = { duration: t(0.2) };
let backgroundVariants = {
  inactive: {
    background: "var(--white)",
    borderColor: "var(--slate-200)",
    color: "var(--slate-400)",
  },
  active: {
    background: "var(--white)",
    borderColor: "var(--green-500)",
    color: "var(--green-500)",
  },
  complete: {
    background: "var(--green-500)",
    borderColor: "var(--green-500)",
  },
};

const HeadStartIndex: NextPageWithLayout = () => {
  const router = useRouter();
  const postId = router.query?.id as string;
  const { data: post } = trpc.post.one.useQuery(postId);
  // configureAbly({ authUrl: "/api/ably" }); // Removed Ably
  const user = useUser();

  const outlineGenerateMutation = trpc.post.createOutline.useMutation();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(post?.title as null | string);
  const [outlinePoints, setOutlinePoints] = useState(
    // @ts-ignore
    post?.outline?.points as any
  );
  const [generating, setGenerating] = useState(false);
  const [generationComplete, setGenerationComplete] = useState(false);
  const [outlineHtml, setOutlineHtml] = useState(undefined as any);
  const timerRef = useRef<any>(null);
  const handleTokenReceived = (token: string) => {
    // Clear the previous timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Set a new timer for 10 seconds
    timerRef.current = setTimeout(() => {
      // Mark the stream as done here
      console.log('Stream is done');
      if (generating && !generationComplete) {
        setGenerating(false);
        setGenerationComplete(true);
        setOutlineRaw(streamRes)
      }

    }, 10000);

    token = token.replace(/<newline>/g, "\n\n");

    setStreamRes((prevContent: string) => {
      if (prevContent === undefined) {
        return token;
      }
      return prevContent + token;
    });
  };
  // Removed Ably channel usage
  // const [_channel, _ably] = useChannel(
  //   user.user?.id + ":outline-" + postId,
  //   (message) => {
  //     // console.log("message", message);
  //     if (message?.data?.token) {
  //       handleTokenReceived(message?.data?.token);
  //     }
  //     if (message?.data?.html) {
  //       console.log("HTML received")
  //       setGenerating(false);
  //       setGenerationComplete(true);
  //       setOutlineRaw(streamRes)
  //       // setOutlineRaw(message?.data?.response)
  //     }
  //   }
  // );

  const [outlineContent, setOutlineContent] = useState(
    // @ts-ignore
    post?.outline?.content as any
  );
  const [outlineRaw, setOutlineRaw] = useState(post?.outlineRaw || ("" as any));
  const [streamRes, setStreamRes] = useState("");
  const id = router.query?.id as string;

  const contentRef = useRef<any>(null);

  useEffect(() => {
    scrollToBottom();
  }, [streamRes]);

  const scrollToBottom = () => {
    contentRef.current.scrollTop = contentRef?.current?.scrollHeight;
  };

  const onUpdate = (markdown: string) => {
    setOutlineRaw(markdown);
  };

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      !generating &&
      !post?.outlineRaw
      // && post?.outlineFeedbackId
    ) {
      const streamTriggered = localStorage.getItem("outline-" + postId);
      if (!streamTriggered) {
        localStorage.setItem("outline-" + postId, "true");

        setGenerating(true);
        outlineGenerateMutation.mutateAsync(postId).then((res) => {
          setGenerating(false);
          setOutlineRaw(streamRes);
          setGenerationComplete(true);
        })
          .catch((err: any) => {
            // setGenerating(false);
            // error handling
            localStorage.removeItem("outline-" + postId);
            // setGenerationComplete(true);
          });
        ;
      }
    }
    return () => { };
  }, []);

  // const savePage = async () => {
  //   setLoading(true);
  //   let data: saveInput = {
  //     title: title as string,

  //     outlineRaw: outlineRaw,
  //     id: id as string,
  //   };
  //   try {
  //     const res = await axios.put("/api/headstart", data);

  //     router.push(`/headstart/${res.data?.id}/points/`);
  //   } catch (error) {
  //     toast.error("Error generating your content. Please try again later.");
  //   }
  // };
  const savePage = async () => {
    setLoading(true);

    let data: saveInput = {
      title: title as string,
      // talkingPoints: {
      //   points: outlineRaw,
      //   content: outlineRaw,
      //   html: outlineRaw,
      // },
      outlineRaw: outlineRaw || streamRes,
      skipParagraphs: false,
      id: id as string,
    };

    try {
      const res = await axios.put("/api/headstart", data);
      router.push(`/headstart/${res.data?.id}/editor/`);
    } catch (error) {
      toast.error("Error generating content, please try again later.");
      setLoading(false);
    }
  };
  function CheckIcon(props) {
    return (
      <svg
        {...props}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={3}
      >
        <motion.path
          variants={checkIconVariants}
          transition={checkIconTransition}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5 13l4 4L19 7"
        />
      </svg>
    );
  }

  return (
    <div className="container mx-auto">
      <Head>
        <title>Moonbeam - Wizard</title>
      </Head>
      {loading && (
        <LoaderOverlay
          className=" w-full h-screen m-0 p-0  z-[1001] bg-opacity-70"
          loadingComponent={
            <LoadingSmall
              iconContainerClassName="h-8 w-8"
              containerClassName=""
            />
          }
        />
      )}

      <div className="flex justify-between">
        <div className="flex-shrink-0">
          <h1 className="block text-sm font-medium text-gray-700 mx-auto">
            Sections
          </h1>
          {generationComplete || post?.outlineRaw ? (
            <h2 className="block text-sm font-medium text-gray-400 mx-auto">{`Hint: Change the outline if you don't like it`}</h2>
          ) : (
            <h2 className="block text-sm font-medium text-gray-400 mx-auto">{`Generating content...`}</h2>
          )}
        </div>
        <AnimatePresence>
          {generating ? (
            <div className=" flex w-full justify-end  items-end  px-2  py-4 ">
              <LoadingSmall
                containerClassName="items-end justify-end"
                iconContainerClassName="h-7 w-7"
              />
            </div>
          ) : (
            <motion.div
              initial="inactive"
              animate="complete"
              variants={backgroundVariants}
              transition={backgroundTransition}
              className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-slate-400 bg-white font-semibold text-slate-500"
            >
              <CheckIcon className="h-6 w-6 text-white" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className="pb-20" ref={contentRef}>
        {generationComplete || post?.outlineRaw ? (
          <>
            <LexicalEditor
              initialMarkdown={outlineRaw || streamRes}
              handleChange={onUpdate}
            />
            <BrandButton onClick={savePage} text={"Create Draft"} />
          </>
        ) : (
          <>
            {!streamRes ? (
              <DummyBars />
            ) : (
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                className="prose  overflow-x-auto "
              >
                {streamRes}
              </ReactMarkdown>
            )}
          </>
        )}
      </div>
    </div>
  );
};
HeadStartIndex.getLayout = (page: any) => (
  <HeadstartLayout>{page}</HeadstartLayout>
);

export const getServerSideProps = withPaywall(async (ctx: any) => {
  const postId = ctx.query.id as string;
  const ssg = createServerSideHelpers({
    router: appRouter,
    ctx: await createContext(ctx),
    transformer: superjson,
  });
  await ssg.post.one.prefetch(postId);
  return {
    props: {
      trpcState: ssg.dehydrate(),
    },
  };
});
export default HeadStartIndex;
